import { Divider, ProductBadge } from '@yanolja-rnd/nol-design-system'
import { getYaNative } from '@yanolja-org/ya-native'
import { useCallback } from 'react'
import { DomesticCartPropertyItem } from '~/api/converters/domestic/cart/ProductSection/Property/index.type'
import PropertyOption from '~/app/components-nds/domestic/cart/cart-product-section/items/property/option'
import { CartPageLog } from '~/app/kinesis/protobuf/clientlogs/order-misc-common-txtpb'
import { isNative } from '~/app/utils/typeguards'

type Props = {
  item: DomesticCartPropertyItem
}

/**
 * 장바구니 > 국내숙소 Item
 */
const PropertyItem = ({ item }: Props) => {
  const { pdpUrl, itemTitle, address, options } = item

  const goToPDP = useCallback(
    async (index?: number) => {
      if (!pdpUrl) return

      const {
        clientLogs: {
          click: { kinesis },
        },
      } = item.options[index || 0]
      kinesis && (await CartPageLog.ProductIdLinkCartOption.click({ productOption: kinesis }))

      const yaNative = getYaNative()
      if (isNative(yaNative)) {
        yaNative.wv({
          method: 'get',
          url: pdpUrl,
        })
      } else {
        location.href = pdpUrl
      }
    },
    [item.options, pdpUrl]
  )

  return (
    <div className="rounded-16 bg-static-white p-16 pf-pc:p-24">
      <ProductBadge type="filled_secondary" size="medium">
        숙소
      </ProductBadge>
      <div className="mt-6 cursor-pointer typography-subtitle-18-bold" onClick={() => goToPDP()}>
        {itemTitle}
      </div>
      <div className="mt-4 text-text-neutral-sub typography-body-13-regular">{address}</div>
      <Divider size="small" type="horizontal" className="mb-20 mt-16" />

      <div className="grid gap-40">
        {options.map((option, idx) => (
          <PropertyOption key={idx} {...option} goToPDP={() => goToPDP(idx)} />
        ))}
      </div>
    </div>
  )
}

export default PropertyItem
